import I18n from 'i18n-js';

window.I18n = I18n;

export default (locale, translations) => {
  window.I18n.translations = {
    [locale]: translations,
  };
};
